import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [count, setCount] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(c => {
        if (c <= 1) { clearInterval(interval); navigate("/app"); }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      minHeight: "100vh", background: "#060d18", display: "flex",
      alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Sans', sans-serif", padding: "2rem",
    }}>
      <link href="https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;700&display=swap" rel="stylesheet" />
      <div style={{
        background: "#111827", borderRadius: 18, padding: "3rem 2.5rem",
        maxWidth: 460, width: "100%", textAlign: "center",
        boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
        border: "1px solid rgba(34,197,94,0.2)",
      }}>
        <div style={{
          width: 64, height: 64, borderRadius: "50%",
          background: "#052e16", border: "2px solid #22c55e",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 1.5rem", fontSize: "1.75rem",
        }}>✓</div>

        <h1 style={{ color: "#22c55e", fontSize: "1.5rem", fontWeight: 800, fontFamily: "'Syne',sans-serif", marginBottom: "0.5rem" }}>
          Your trial has started.
        </h1>
        <p style={{ color: "#9ca3af", fontSize: "0.9rem", lineHeight: 1.7, marginBottom: "0.5rem" }}>
          You have 14 days free. All Pro features are unlocked.
        </p>
        <p style={{ color: "#6b7280", fontSize: "0.8rem", lineHeight: 1.7, marginBottom: "2rem" }}>
          Your card won't be charged until the trial ends. Cancel anytime before then.
        </p>

        <button onClick={() => navigate("/app")} style={{
          background: "#22c55e", color: "white", border: "none",
          borderRadius: 10, padding: "0.85rem 2rem",
          fontWeight: 700, fontSize: "0.95rem", cursor: "pointer",
          fontFamily: "'Syne',sans-serif", width: "100%",
        }}>
          Go to dashboard →
        </button>
        <p style={{ color: "#374151", fontSize: "0.8rem", marginTop: "1rem" }}>
          Redirecting automatically in {count}s
        </p>
      </div>
    </div>
  );
}
